import {
    type GetContactProfileOutput,
    getTimeZoneOptions,
    toUsStateName,
    type UpdateContactProfileInput,
} from '@/entities/client';
import { formatPhone } from '@/shared/lib/format-utils';

// Prefill from the saved record, empty where nothing is saved. The preferences and pronouns stay
// null when unsaved so neither option opens selected.
export function buildEditContactProfileDefaults(
    profile: GetContactProfileOutput,
): UpdateContactProfileInput {
    return {
        id: profile.personId,
        firstName: profile.firstName,
        lastName: profile.lastName,
        preferredFirstName: profile.preferredFirstName,
        emailPrimary: profile.emailPrimary ?? '',
        phonePrimary: formatPhone(profile.phonePrimary),
        // The command accepts only the curated zones, so a stored zone outside them reads as unset
        // instead of sending a value the server would refuse.
        timeZone:
            getTimeZoneOptions().find((zone) => zone.value === profile.timeZone)?.value ?? null,
        address: {
            street1: profile.address?.street1 ?? '',
            street2: profile.address?.street2 ?? '',
            city: profile.address?.city ?? '',
            state: toUsStateName(profile.address?.state ?? ''),
            zip: profile.address?.zip ?? '',
        },
        okToEmail: profile.okToEmail,
        okToCallText: profile.okToCallText,
        pronouns: profile.pronouns || null,
    };
}
